import { gql } from 'apollo-angular';

export const userNotes = gql`
	fragment UserNotes on UserNoteOutput {
		id
		note
		type
		visibility
		creationTimestamp
		user {
			id
		}
		target {
			id
		}
	}
`;

export const userNote = gql`
	fragment UserNote on UserNoteOutput {
		...UserNotes
	}
	${userNotes}
`;
